import { useState } from 'react';

import { isFirstLoad, allmenu, isSingin } from '../redux/slices/initLoad/types';
import { store } from '../redux/store';
import request from '../helpers/requests';
import { saveData, saveImage, getImage } from '../helpers/indexedDbHelper';

export const useInit = () => {
  const [progress, setProgress] = useState(0);

  const downloadImage = async (url, id, changeimage) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      await saveImage(id, { blob, changeimage });
    } catch (error) {
      console.error(`Error al descargar la imagen ${id}:`, error);
    }
  };

  const validImages = async (id) => {
    console.log('validando imagen');
    const data = await getImage(id);
    console.log('imagen validada');
    return data;
  };

  const getInitData = async () => {
    const hash = '7110eda4d09e062aa51e4a390b0a572ac211aag2FA';

    const { data } = await request.get(`/all/menu/web/${hash}`);
    console.log('guardando menu');
    await saveData('menu', data);
    console.log('menu guardado');

    // Crear una lista de promesas para todas las imágenes
    const imagesData = [];
    data.data.forEach((item) => {
      const images = [
        ...item.menus.map((menu) => ({
          url: menu.image,
          changeimage: menu.changeimage,
          id: `menu-image-${menu.id}`,
        })),
        ...item.menus.map((menu) => ({
          url: menu.imagehorizontal,
          changeimage: menu.changeimagehorizontal,
          id: `menu-image-h-${menu.id}`,
        })),
        ...item.menus.map((menu) => ({
          url: menu.image1,
          changeimage: menu.changeimage1,
          id: `menu-image-one-${menu.id}`,
        })),
        ...item.menus.map((menu) => ({
          url: menu.image2,
          changeimage: menu.changeimage2,
          id: `menu-image-two-${menu.id}`,
        })),
      ];

      imagesData.push(...images);
    });

    fetchImagesInBatches(imagesData, 10, setProgress)
      .then(async () => {
        console.log('Esperar a que todas las imágenes se descarguen');
        // Esperar a que todas las imágenes se descarguen
        console.log('terminando imágenes se descarguen');
        // Actualizar el estado de Redux
        console.log('terminar proceso');
        store.dispatch(isSingin(true));
        store.dispatch(isFirstLoad(false));
      })
      .catch((error) => {
        console.log('Error management => ', error);
        store.dispatch(isSingin(true));
        store.dispatch(isFirstLoad(false));
      });
  };

  function fetchImagePromise(imageData) {
    const { url, id, changeimage } = imageData;
    if (url) {
      return new Promise((resolve, reject) => {
        const fullUrl = `https://tumenu.online/images/menus/${url}`;
        validImages(id)
          .then((validImage) => {
            if (
              !validImage ||
              !validImage.data ||
              validImage.data.changeimage != changeimage
            ) {
              downloadImage(fullUrl, id, changeimage)
                .then(() => {
                  resolve(true);
                })
                .catch(() => {
                  reject(false);
                });
            } else {
              resolve(true);
            }
          })
          .catch(() => {
            reject(false);
          });
      });
    }
    return null;
  }

  async function fetchImagesInBatches(data, batchSize = 20, onProgress) {
    const results = [];
    let completed = 0;

    for (let i = 0; i < data.length; i += batchSize) {
      const batch = data.slice(i, i + batchSize);

      const batchResults = await Promise.allSettled(
        batch.map(async (dt) => {
          await fetchImagePromise(dt);
          completed++;
          if (onProgress) {
            const percentage = ((completed / data.length) * 100).toFixed(2);
            onProgress(percentage);
          }
        }),
      );

      results.push(...batchResults);
    }

    return results;
  }

  const isGoodConnection = () => {
    const connection =
      navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection;
    if (connection) {
      const slowConnections = ['slow-2g', '2g'];
      if (
        slowConnections.includes(connection.effectiveType) ||
        connection.saveData
      ) {
        return false;
      }
    }
    return true;
  };

  const hasInternetAccess = async () => {
    try {
      const response = await fetch('https://tumenu.online/api/health', {
        method: 'GET',
        cache: 'no-store',
      });

      return response.ok;
    } catch (error) {
      return false;
    }
  };

  const checkAndStart = async () => {
    const online = navigator.onLine;
    const goodConnection = isGoodConnection();
    const hasInternet = await hasInternetAccess();

    if (online && goodConnection && hasInternet) {
      console.log('Conexión ok, comenzando init...');
      // store.dispatch(isSingin(true));
      // store.dispatch(isFirstLoad(false));
      getInitData();
    } else {
      console.log('Sin conexión real o conexión muy lenta. Esperando...');
      store.dispatch(isSingin(true));
      store.dispatch(isFirstLoad(false));
    }
  };

  return { progress: progress, setProgress, checkAndStart };
};
